document.addEventListener('DOMContentLoaded', () => {
    
    // Ensure GSAP and ScrollTrigger are loaded
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
        // iOS Safari/Brave toolbar expansion must not repeatedly remeasure scrubbed sections.
        ScrollTrigger.config({ ignoreMobileResize: true });

        // Cleaned up old bottleSection

        // Hero Section Animations
        const heroSection = document.getElementById('hero-section');
        const heroMedia = document.querySelector('.gsap-hero-media');
        const heroBg = document.querySelector('.gsap-hero-bg');
        // Target only the centered ADAMEA mark, not the bottle or background video.
        const heroLogo = heroBg?.querySelector('.hero-bg-element, .hero-text-element');
        const heroProduct = document.querySelector('.gsap-hero-product');
        const heroFades = document.querySelectorAll('.gsap-hero-fade');

        // 1. Initial Load Animations (coordinated to not clash)
        const heroTl = gsap.timeline();
        if (heroLogo) gsap.set(heroLogo, { filter: 'blur(0px)' });
        
        // Prevent FOUC: Elements are hidden in CSS, make them visible for GSAP to animate them
        if (heroMedia) gsap.set(heroMedia, { visibility: 'visible' });
        if (heroBg) gsap.set(heroBg, { visibility: 'visible' });
        if (heroProduct) gsap.set(heroProduct, { visibility: 'visible' });
        if (heroFades.length > 0) gsap.set(heroFades, { visibility: 'visible' });

        if (heroMedia) {
            heroTl.from(heroMedia, {
                opacity: 0,
                duration: 2.5,
                ease: "power2.inOut"
            }, 0);
        }

        if (heroBg) {
            heroTl.from(heroBg, {
                scale: 1.1,
                opacity: 0,
                duration: 1.5,
                ease: "power2.out"
            }, 0.5); // Starts slightly after the video begins fading in
        }
        
        if (heroProduct) {
            heroTl.from(heroProduct, {
                y: 50,
                opacity: 0,
                duration: 1.5,
                ease: "power3.out"
            }, 1.5); // Starts after logo
        }

        // Smooth depth of field as the bottle appears. The logo starts sharp,
        // then softens gently; the bottle, backdrop and other timing stay unchanged.
        if (heroLogo) {
            heroTl.to(heroLogo, {
                filter: 'blur(2.8px)',
                duration: 1.6,
                ease: 'sine.inOut'
            }, 1.55);
        }

        if (heroFades.length > 0) {
            heroTl.from(heroFades, {
                y: 30,
                opacity: 0,
                duration: 1,
                stagger: 0.2,
                ease: "power2.out"
            }, 2.0); // Starts after bottle
        }

        // Reveal the existing header only after the full hero entrance is complete.
        // CSS hides its content on the homepage until this callback; no hero markup is changed.
        if (heroSection) {
            heroTl.eventCallback('onComplete', () => {
                document.getElementById('adamea-header')?.classList.add('is-hero-ready');
            });
        }

        // 2. Global Section Fade-Out (Only apply to Hero Section)
        
        // Hide header logic
        const navHeader = document.getElementById('adamea-header');
        const rollingBottleSection = document.getElementById('bottle-scroll-section');
        
        if (navHeader) {
            if (heroSection && rollingBottleSection) {
                // Homepage: Hide only when reaching Rolling Bottle section
                gsap.to(navHeader, {
                    scrollTrigger: {
                        trigger: rollingBottleSection,
                        start: "top top",
                        end: "bottom top",
                        scrub: true
                    },
                    yPercent: -100,
                    opacity: 0,
                    ease: "none"
                });
            } else {
                // Product Page / Other Pages: Fast scroll-down hide
                let lastScroll = window.pageYOffset;
                let previousHidden = false;
                window.addEventListener('scroll', () => {
                    const currentScroll = window.pageYOffset;
                    const hidden = currentScroll > 100 && currentScroll > lastScroll;
                    const shouldShow = currentScroll <= 100 || currentScroll < lastScroll;
                    if ((hidden || shouldShow) && hidden !== previousHidden) {
                        gsap.to(navHeader, { yPercent: hidden ? -100 : 0, opacity: hidden ? 0 : 1, duration: 0.3, ease: "power2.out", overwrite: true });
                        previousHidden = hidden;
                    }
                    lastScroll = Math.max(0, currentScroll);
                }, { passive: true });
            }
        }
        
        // Allow natural, stable scrolling on mobile; keep the existing desktop
        // hero fade + lift. matchMedia removes this tween on narrow screens.
        if (heroSection) {
            const heroWrapper = heroSection.closest('.shopify-section') || heroSection;
            gsap.matchMedia().add("(min-width: 768px)", () => {
                gsap.to(heroWrapper, {
                    scrollTrigger: {
                        trigger: heroWrapper,
                        start: "top top",
                        end: "bottom top",
                        scrub: true
                    },
                    opacity: 0,
                    y: -100,
                    ease: "none"
                });
            });
        }

        // Removed Fade IN the header logo



        // 3. Marquee Animation (Handled via CSS now for better mobile performance)

        // 3.5 Magnetic / Parallax Effect for Hero Bottle (Desktop Only)
        if (heroProduct && window.matchMedia("(min-width: 768px)").matches) {
            heroSection.addEventListener("mousemove", (e) => {
                const { clientX, clientY } = e;
                const { left, top, width, height } = heroSection.getBoundingClientRect();
                
                // Calculate percentage from center of the screen
                const xPos = (clientX - left - width / 2) / (width / 2);
                const yPos = (clientY - top - height / 2) / (height / 2);

                gsap.to(heroProduct, {
                    x: xPos * 30, // Max move 30px
                    y: yPos * 30, 
                    rotationY: xPos * 10,
                    rotationX: -yPos * 10,
                    ease: "power2.out",
                    duration: 1
                });
            });

            heroSection.addEventListener("mouseleave", () => {
                gsap.to(heroProduct, {
                    x: 0,
                    y: 0,
                    rotationY: 0,
                    rotationX: 0,
                    ease: "power3.out",
                    duration: 1.5
                });
            });
        }

        // Mobile gyroscope deliberately disabled; hero entrance and scroll animations are unchanged.

        // 4. Collection Reveal Scroll Logic — long, cinematic holds for both collections.
        // Only this ScrollTrigger is retimed; bottle assets, layouts and all other animations stay intact.
        const bottleSection = document.getElementById('bottle-scroll-section');
        if (bottleSection) {
            const mm = gsap.matchMedia();
            mm.add({
                isMobile: "(max-width: 767px)",
                isDesktop: "(min-width: 768px)"
            }, (context) => {
                const { isMobile } = context.conditions;
                const dodgeDown = isMobile ? "10vh" : "0px";
                const dodgeUp = isMobile ? "-10vh" : "0px";

                // Timeline length = 10: 0–1.6 introduction, 1.6–3.65
                // Memory Atlas hold, 3.65–6.6 crossfade, 6.6–10 Everyday Edit hold.
                // The tall section supplies scroll distance while CSS sticky holds each frame.
                const tl = gsap.timeline({
                    defaults: { ease: "sine.inOut" },
                    scrollTrigger: {
                        trigger: bottleSection,
                        start: "top top",
                        end: "bottom bottom",
                        scrub: isMobile ? 1.8 : 1.45,
                        invalidateOnRefresh: true
                    }
                });

                // Keep the second bottle aligned behind the first before crossfading.
                tl.set("#scrolling-bottle-2", { y: dodgeDown }, 0);

                // Chapter I: gently reveal The Memory Atlas and hold the fully formed frame.
                tl.to(["#info-1", "#list-1"], {
                    opacity: 1, y: 0, duration: 1.0, ease: "sine.out"
                }, 0.2);
                tl.to("#scrolling-bottle-1", {
                    y: dodgeDown, duration: 1.35
                }, 0.2);

                // Chapter change: allow both bottles and background titles to crossfade
                // without a sudden swap or a jump in bottle position.
                tl.to(["#info-1", "#list-1"], {
                    opacity: 0, y: -20, duration: 1.15
                }, 3.65);
                tl.to("#scrolling-bottle-1", {
                    opacity: 0, duration: 1.65
                }, 4.05);
                tl.to("#scrolling-bottle-2", {
                    opacity: 1, duration: 1.65
                }, 4.05);
                tl.to("#bg-text-1", {
                    opacity: 0, y: -50, duration: 1.45
                }, 4.05);
                tl.to("#bg-text-2", {
                    opacity: 1, y: 0, duration: 1.45
                }, 4.20);

                // Chapter II: reveal The Everyday Edit after the overlap, then hold.
                tl.to(["#info-2", "#list-2"], {
                    opacity: 1, y: 0, duration: 1.1, ease: "sine.out"
                }, 5.15);
                tl.to("#scrolling-bottle-2", {
                    y: dodgeUp, duration: 1.5
                }, 5.15);

                // Extend the finished frame through the section end (no invisible
                // DOM elements or global scroll locking).
                const hold = { value: 0 };
                tl.set(hold, { value: 1 }, 10);

                return () => {
                    tl.kill();
                    gsap.set(["#scrolling-bottle-1", "#scrolling-bottle-2"], { clearProps: "y" });
                };
            });
        }

        // 5. Global Scroll Fade Up
        const fadeUpElements = document.querySelectorAll('.gsap-fade-up');
        fadeUpElements.forEach(el => {
            gsap.fromTo(el, 
                { opacity: 0, y: 30 },
                { 
                    opacity: 1, 
                    y: 0, 
                    duration: 1, 
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: el,
                        start: "top 85%", // Triggers when the top of the element hits 85% down the viewport
                    }
                }
            );
        });

        // 6. Mood Carousel Logic
        const track = document.querySelector('.adamea-carousel-track');
        if (track) {
            const items = document.querySelectorAll('.adamea-carousel-item');
            const prevBtn = document.getElementById('adamea-carousel-prev');
            const nextBtn = document.getElementById('adamea-carousel-next');
            const dotsContainer = document.getElementById('adamea-carousel-dots');
            
            // Create dots
            items.forEach((_, i) => {
                const dot = document.createElement('div');
                dot.classList.add('w-2', 'h-2', 'rounded-full', 'bg-white/20', 'transition-colors', 'cursor-pointer');
                if (i === 0) dot.classList.replace('bg-white/20', 'bg-white');
                dotsContainer.appendChild(dot);
                
                dot.addEventListener('click', () => {
                    track.scrollTo({
                        left: items[i].offsetLeft - (track.clientWidth / 2) + (items[i].clientWidth / 2),
                        behavior: 'smooth'
                    });
                });
            });

            const dots = dotsContainer.children;

            const updateActiveItem = () => {
                const trackCenter = track.scrollLeft + track.clientWidth / 2;
                let closestIndex = 0;
                let minDistance = Infinity;
                
                // Max distance from center before element is completely invisible
                const maxDist = track.clientWidth * 0.5;

                items.forEach((item, index) => {
                    const itemCenter = item.offsetLeft + item.clientWidth / 2;
                    const distance = Math.abs(trackCenter - itemCenter);
                    
                    // Calculate smooth progress 0 to 1
                    let progress = 1 - (distance / maxDist);
                    if (progress < 0) progress = 0;
                    
                    // Smooth easing for a buttery effect
                    const easedProgress = Math.pow(progress, 1.5);
                    
                    const scale = 0.85 + (easedProgress * 0.15); // Scales from 0.85 to 1.0
                    
                    gsap.set(item, {
                        opacity: easedProgress,
                        scale: scale
                    });
                    
                    if (distance < minDistance) {
                        minDistance = distance;
                        closestIndex = index;
                    }
                });

                Array.from(dots).forEach((dot, index) => {
                    if (index === closestIndex) {
                        dot.classList.replace('bg-white/20', 'bg-white');
                    } else {
                        dot.classList.replace('bg-white', 'bg-white/20');
                    }
                });
            };

            let carouselFramePending = false;
            track.addEventListener('scroll', () => {
                if (carouselFramePending) return;
                carouselFramePending = true;
                window.requestAnimationFrame(() => {
                    carouselFramePending = false;
                    updateActiveItem();
                });
            }, { passive: true });

            // Initial setup run
            setTimeout(() => {
                updateActiveItem();
                // Scroll to center first item perfectly on load if needed
                track.scrollTo({ left: 0, behavior: 'auto' });
            }, 100);

            if (nextBtn) {
                nextBtn.addEventListener('click', () => {
                    // Scroll exactly one item width + gap
                    const scrollAmount = items[0].clientWidth;
                    track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
                });
            }
            if (prevBtn) {
                prevBtn.addEventListener('click', () => {
                    const scrollAmount = items[0].clientWidth;
                    track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
                });
            }
        }
        
        // 6. Product Details Page (PDP) Animations
        const productImage = document.querySelector('.gsap-product-image');
        if (productImage) {
            gsap.to(productImage, {
                opacity: 1,
                y: 0,
                duration: 1.5,
                ease: "power3.out",
                delay: 0.2
            });
        }
        
        // Thumbnail swapping logic
        const thumbnails = document.querySelectorAll('.thumbnail-btn');
        const mainImage = document.getElementById('main-product-image');
        
        if (thumbnails.length > 0 && mainImage) {
            thumbnails.forEach(btn => {
                btn.addEventListener('click', () => {
                    // Update active state
                    thumbnails.forEach(t => {
                        t.classList.remove('active', 'border-white/50');
                        t.classList.remove('opacity-100');
                        t.classList.add('opacity-60');
                    });
                    btn.classList.add('active', 'border-white/50', 'opacity-100');
                    btn.classList.remove('opacity-60');
                    
                    // Crossfade animation
                    const newSrc = btn.getAttribute('data-image-src');
                    gsap.to(mainImage, {
                        opacity: 0,
                        duration: 0.3,
                        onComplete: () => {
                            mainImage.src = newSrc;
                            // Reset srcset if it's an image tag generated by shopify
                            mainImage.removeAttribute('srcset');
                            gsap.to(mainImage, { opacity: 1, duration: 0.5, ease: "power2.out" });
                        }
                    });
                });
            });
        }
        
          // Discover Signature Stagger Animation
        const discoverSections = document.querySelectorAll('.gsap-discover-section');
        discoverSections.forEach(section => {
            const container = section.querySelector('.gsap-discover-container');
            if (!container) return;
            
            const buttons = container.querySelector('.gsap-discover-buttons');
            const image = container.querySelector('.gsap-discover-image');
            
            // Image Scrub
            if (image) {
                // Set initial state
                gsap.set(image, { "--reveal-stop": "-10%", opacity: 0, x: -20 });
                
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: "top top", // Starts animating when the section hits top of screen
                        end: "bottom bottom", // Finishes when the bottom of the section hits bottom of screen
                        scrub: 1
                    }
                });
                
                // Animate image reveal with a soft wipe from left to right
                tl.to(image, {
                    "--reveal-stop": "100%",
                    x: 0,
                    opacity: 1,
                    duration: 2, // Takes up more of the scroll distance to slow it down
                    ease: "none" // Removes the slow-start 'delay' by making the scrub perfectly linear
                });
                
                if(buttons) {
                    tl.from(buttons, {
                        opacity: 0,
                        y: 30,
                        duration: 0.5,
                        ease: "power2.out"
                    });
                }
                
                tl.to(image, { duration: 1.5 }); // Huge hold at the end to keep the section fully visible for 1.5 screens before moving on
            }
        });
        
        // ==========================================
        // AJAX CART DRAWER LOGIC
        // ==========================================
        const cartDrawer = document.getElementById('adamea-cart-drawer');
        const cartPanel = document.getElementById('cart-drawer-panel');
        const cartBackdrop = document.getElementById('cart-drawer-backdrop');
        const cartCloseBtn = document.getElementById('cart-drawer-close');
        const cartContinueBtn = document.getElementById('cart-drawer-continue');
        const cartIcons = document.querySelectorAll('a[href="/cart"]');
        const addToCartForm = document.getElementById('product-form');

        const openCartDrawer = () => {
            if (cartDrawer) {
                cartDrawer.classList.remove('pointer-events-none');
                cartBackdrop.classList.remove('opacity-0');
                cartBackdrop.classList.add('opacity-100', 'pointer-events-auto');
                cartPanel.classList.remove('translate-x-full');
            }
        };

        const closeCartDrawer = () => {
            if (cartDrawer) {
                cartBackdrop.classList.remove('opacity-100', 'pointer-events-auto');
                cartBackdrop.classList.add('opacity-0');
                cartPanel.classList.add('translate-x-full');
                setTimeout(() => {
                    cartDrawer.classList.add('pointer-events-none');
                }, 500);
            }
        };

        if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCartDrawer);
        if (cartBackdrop) cartBackdrop.addEventListener('click', closeCartDrawer);
        
        // Prevent default cart page navigation on all cart icons
        if (cartIcons.length > 0) {
            cartIcons.forEach(icon => {
                icon.addEventListener('click', (e) => {
                    e.preventDefault();
                    updateCartDrawer();
                    openCartDrawer();
                });
            });
        }

        // Delegate events for dynamically loaded content
        if (cartDrawer) {
            cartDrawer.addEventListener('click', (e) => {
                if (e.target.closest('#cart-drawer-continue')) {
                    closeCartDrawer();
                }
                
                const qtyBtn = e.target.closest('.cart-qty-btn');
                if (qtyBtn) {
                    const line = qtyBtn.getAttribute('data-line');
                    const qty = qtyBtn.getAttribute('data-qty');
                    changeCartQuantity(line, qty);
                }
            });
        }

        // Add to Cart Intercept
        if (addToCartForm) {
            addToCartForm.addEventListener('submit', (e) => {
                e.preventDefault();
                
                // Submit via fetch
                const formData = new FormData(addToCartForm);
                fetch('/cart/add.js', {
                    method: 'POST',
                    body: formData
                })
                .then(response => response.json())
                .then(data => {
                    updateCartDrawer();
                    openCartDrawer();
                })
                .catch((error) => {
                    console.error('Error adding to cart:', error);
                });
            });
        }

        const updateCartDrawer = () => {
            // Fetch the cart-drawer section rendering API
            fetch('/?section_id=cart-drawer')
                .then(response => response.text())
                .then(html => {
                    const temp = document.createElement('div');
                    temp.innerHTML = html;
                    
                    const newContents = temp.querySelector('#cart-drawer-contents');
                    const newFooter = temp.querySelector('.border-t.border-white\\/10'); // Footer
                    
                    const oldContents = document.getElementById('cart-drawer-contents');
                    const oldFooterWrapper = cartPanel; // We'll replace the footer inside the panel
                    
                    if (oldContents && newContents) {
                        oldContents.innerHTML = newContents.innerHTML;
                    }
                    
                    // Re-inject footer
                    const existingFooter = oldFooterWrapper.querySelector('.border-t.border-white\\/10');
                    if (existingFooter) existingFooter.remove();
                    if (newFooter) {
                        oldFooterWrapper.appendChild(newFooter);
                    }
                })
                .catch(error => console.error('Error updating cart drawer:', error));
        };

        const changeCartQuantity = (line, qty) => {
            fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    line: line,
                    quantity: qty
                })
            })
            .then(response => response.json())
            .then(data => {
                updateCartDrawer();
            })
            .catch((error) => {
                console.error('Error changing cart quantity:', error);
            });
        };
        
        // 7. General Text Fades
        const textFades = document.querySelectorAll('.gsap-text-fade');
        textFades.forEach(el => {
            gsap.from(el, {
                scrollTrigger: {
                    trigger: el,
                    start: "top 85%"
                },
                opacity: 0,
                y: 20,
                duration: 1,
                ease: "power2.out"
            });
        });

        // 8. Letter by Letter Reveal
        const letterReveals = document.querySelectorAll('.gsap-letter-reveal');
        letterReveals.forEach(el => {
            // Only split text nodes, preserve HTML structure if any
            if (el.children.length === 0) {
                const text = el.innerText;
                el.innerHTML = '';
                // Split text into words, then words into letters, to preserve wrapping gracefully
                const words = text.split(' ');
                words.forEach((word, wordIndex) => {
                    const wordSpan = document.createElement('span');
                    wordSpan.className = "inline-block whitespace-nowrap";
                    
                    word.split('').forEach(char => {
                        const charSpan = document.createElement('span');
                        charSpan.innerText = char;
                        charSpan.className = "inline-block opacity-0 translate-y-4";
                        wordSpan.appendChild(charSpan);
                    });
                    
                    el.appendChild(wordSpan);
                    
                    if (wordIndex < words.length - 1) {
                        const spaceSpan = document.createElement('span');
                        spaceSpan.innerHTML = '&nbsp;';
                        spaceSpan.className = "inline-block";
                        el.appendChild(spaceSpan);
                    }
                });
                
                // Animate the characters
                const chars = el.querySelectorAll('span > span.opacity-0');
                gsap.to(chars, {
                    scrollTrigger: {
                        trigger: el,
                        start: "top 85%"
                    },
                    opacity: 1,
                    y: 0,
                    duration: 0.6,
                    stagger: 0.015,
                    ease: "power2.out"
                });
            }
        });
        
        // ==========================================
        // SEARCH DRAWER LOGIC
        // ==========================================
        const searchDrawer = document.getElementById('adamea-search-drawer');
        const searchPanel = document.getElementById('search-drawer-panel');
        const searchBackdrop = document.getElementById('search-drawer-backdrop');
        const searchCloseBtn = document.getElementById('search-drawer-close');
        const searchIcons = document.querySelectorAll('a[href="/search"]');
        const searchInput = document.getElementById('SearchInput');
        const searchResultsContainer = document.getElementById('predictive-search-results');
        
        let searchTimeout = null;

        const openSearchDrawer = () => {
            if (searchDrawer) {
                searchDrawer.classList.remove('pointer-events-none');
                searchBackdrop.classList.remove('opacity-0');
                searchBackdrop.classList.add('opacity-100', 'pointer-events-auto');
                searchPanel.classList.remove('-translate-y-full');
                setTimeout(() => {
                    if (searchInput) searchInput.focus();
                }, 300);
            }
        };

        const closeSearchDrawer = () => {
            if (searchDrawer) {
                searchBackdrop.classList.remove('opacity-100', 'pointer-events-auto');
                searchBackdrop.classList.add('opacity-0');
                searchPanel.classList.add('-translate-y-full');
                setTimeout(() => {
                    searchDrawer.classList.add('pointer-events-none');
                }, 500);
            }
        };

        if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearchDrawer);
        if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearchDrawer);
        
        if (searchIcons.length > 0) {
            searchIcons.forEach(icon => {
                icon.addEventListener('click', (e) => {
                    e.preventDefault();
                    openSearchDrawer();
                });
            });
        }
        
        // Predictive Search API Call
        if (searchInput && searchResultsContainer) {
            const defaultHTML = searchResultsContainer.innerHTML; // Store best sellers
            
            searchInput.addEventListener('input', (e) => {
                const query = e.target.value.trim();
                
                clearTimeout(searchTimeout);
                
                if (query.length === 0) {
                    searchResultsContainer.innerHTML = defaultHTML;
                    return;
                }
                
                searchTimeout = setTimeout(() => {
                    // Call Shopify Predictive Search API
                    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`)
                        .then(response => response.json())
                        .then(data => {
                            const products = data.resources.results.products;
                            if (products && products.length > 0) {
                                let html = `<div class="col-span-full mb-2"><h3 class="text-[9px] md:text-[10px] uppercase tracking-[0.3em] text-gray-500">Search Results</h3></div>`;
                                products.forEach(product => {
                                    html += `
                                        <a href="${product.url}" class="group flex flex-col p-4 md:p-6 rounded-2xl bg-white/[0.03] backdrop-blur-xl border border-white/10 hover:bg-white/[0.08] hover:border-white/20 transition-all duration-300">
                                            <div class="w-full aspect-[4/5] rounded-xl overflow-hidden mb-4 md:mb-6 bg-black/30 flex items-center justify-center p-3 md:p-4">
                                                <img src="${product.image || 'bottle.png'}" class="w-full h-full object-contain transition-transform duration-700 group-hover:scale-110 drop-shadow-2xl mix-blend-screen" alt="${product.title}">
                                            </div>
                                            <h4 class="font-serif text-sm md:text-base tracking-widest uppercase group-hover:text-gray-300 transition-colors">${product.title}</h4>
                                            <span class="text-[9px] md:text-[10px] uppercase tracking-[0.2em] text-gray-500 mt-2">${product.price}</span>
                                        </a>
                                    `;
                                });
                                searchResultsContainer.innerHTML = html;
                            } else {
                                searchResultsContainer.innerHTML = `<div class="col-span-full py-12 text-center"><p class="text-gray-400 font-serif text-2xl tracking-widest uppercase">No products found</p></div>`;
                            }
                        })
                        .catch(err => {
                            console.error('Error fetching predictive search:', err);
                        });
                }, 300); // 300ms debounce
            });
        }

        // Recalculate all ScrollTriggers to account for pinning layout shifts
        ScrollTrigger.sort();
        ScrollTrigger.refresh();
    }
});
